import { CProgress } from '@coreui/react';
import * as React from 'react';

export interface IProgressParams {
	Min: number,
	Max: number,
	ProgressColor: string,
	Visible: boolean,
}

interface IProps {
	Value: string,
	ctrl: IProgressParams
}

interface IState {
}

// Affiche un composant qui d�clenchera un t�l�chargement lors d'un clic
export class KProgress extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
	
		this.state = {
		};
	}

	//#region Local events

	//#endregion 

	//#region Rendus

	render() {
		let ctrl = this.props.ctrl;
		if ((ctrl == null) || (ctrl==undefined)) return null;
		if (!ctrl.Visible) return null;
		let striped = false;
		let anim = false;

		let color = "primary";
		try {

			if (!ctrl.ProgressColor) ctrl.ProgressColor = "blue";

			let steps = ctrl.ProgressColor.split(";");

			if (steps.indexOf("striped") != -1) {
				steps.splice(steps.indexOf("striped"), 1)
				striped = true;
			}

			if (steps.indexOf("animated") != -1) {
				steps.splice(steps.indexOf("animated"), 1)
				anim = true;
			}

			if (steps.length > 1) {
				for (let step of steps) {
					let parts = step.split("=");
					let max = 100;
					if (parts.length > 1) max = Number(parts[1]);
					if (max == undefined) max = 100;
					if (Number(this.props.Value) <= max) {
						color = parts[0];
						break;
					}
				}
			}
			else {
				// Au cas o� la valeur soit 'success=xx' on ne garde que 'success'
				color = ctrl.ProgressColor.split("=")[0];
			}
		}
		catch (err) {
			color = "primary";
			console.log(err)
		}

		return (
			<div className="KProgress">
				<CProgress showValue
					className="mb-1 bg-white"
					animated={anim}
					striped={striped}
					value={this.props.Value}
					min={ctrl.Min}
					max={ctrl.Max}
					color={color} />
				
			</div>
		)
	}

	//#endregion 

}
